<!-- Login Page Section Start -->
<div class="login-page-wrap h-screen">
    <div class="login-page-inner sm:h-full w-full bg-[url('/assets/images/doctors/3.jpg')] bg-cover bg-center relative">
        <div class="login-page-left md:h-full relative">
            <div class="login-content-wrap container p-[20px] h-full grid grid-cols-12 items-center">
                <div class="login-content col-span-12 lg:col-span-8 z-10 mb-[2em]">
                    <h3 class="primary-title text-white font-bold mb-0 text-[1.4em] md:text-[1.7em] lg:text-[2.5em] xl:text-[3em] max-w-[80%]">Your Gateway to Convenient Online Healthcare</h3>
                    <p class="text-white font-light lg:w-9/12 text-[14px] md:text-[20px] lg:text-xl">
                        Start managing your healthcare with ease. Log in to access a wide range of specialists, book appointments, and consult with doctors online—all from the comfort of your home. Your healthcare, your way.
                    </p>
                    <img src="/assets/images/medease-logo-white.png" alt="medease-logo"
                        class="w-[250px] object-contain lg:mt-10">
                </div>
                <div class="login-form-container col-span-12 lg:col-span-4 w-full h-auto z-10">
                    <app-message></app-message>
                    <app-login></app-login>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Login Page Section End -->